module.exports = __webpack_public_path__ + "static/media/fwd-light.60a6c89e.svg";